import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { styles } from '../styles';

export const OrderSummaryRow = ({ k, v }) => (
  <>
    {v ? (
      <View style={styles.dl}>
        <Text style={styles.dt}>{k}</Text>
        <Text style={styles.dd}>{v}</Text>
      </View>
    ) : null}
  </>
);
